import { CHAT_NOTIFIER_LOAD_SUCCESS, CHAT_NOTIFIER_LOAD_URL } from 'moduleChatNotifier/constants';

var chatNotifierLoadSuccess = function chatNotifierLoadSuccess(data) {
  return {
    type: CHAT_NOTIFIER_LOAD_SUCCESS,
    payload: {
      countNotViewed: data.countNotViewed
    }
  };
};

var chatNotifierLoad = function chatNotifierLoad(page) {
  return function (dispatch, getState, _ref) {
    var networkService = _ref.networkService;
    return networkService.getSimple(CHAT_NOTIFIER_LOAD_URL, {
      params: {
        page: page
      }
    }).then(function (response) {
      dispatch(chatNotifierLoadSuccess(response.data));
      return response;
    });
  };
};

export { chatNotifierLoad };